'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.interpolateSegmentWordTimings = exports.getEstimatedWordDuration = exports.getWordDurationEquation = exports.stripPunctuation = exports.getWords = exports.getSegments = exports.getComponents = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _immutable = require('immutable');

var _immutable2 = _interopRequireDefault(_immutable);

var _Speaker = require('../Speaker');

var _Speaker2 = _interopRequireDefault(_Speaker);

var _TranscriptSegment = require('../TranscriptSegment');

var _TranscriptSegment2 = _interopRequireDefault(_TranscriptSegment);

var _TranscriptWord = require('../TranscriptWord');

var _TranscriptWord2 = _interopRequireDefault(_TranscriptWord);

var _Transcript = require('../Transcript');

var _Transcript2 = _interopRequireDefault(_Transcript);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

var matchAll = function matchAll(regex, text) {
  var matches = [];
  var match = null;
  // eslint-disable-next-line no-cond-assign
  while ((match = regex.exec(text)) !== null) {
    matches.push(match);
  }
  return matches;
};

var getComponents = exports.getComponents = function getComponents(text, delimeter) {
  var matches = matchAll(delimeter, text);

  var componentRanges = [];

  matches.forEach(function (match, index) {
    if (componentRanges.length === 0) {
      componentRanges.push({
        startIndex: 0,
        endIndex: match.index
      });
    }

    componentRanges.push({
      startIndex: match.index + match[0].length,
      endIndex: matches[index + 1] ? matches[index + 1].index : text.length
    });
  });

  var components = componentRanges.map(function (segment) {
    return _extends({}, segment, {
      text: text.substring(segment.startIndex, segment.endIndex)
    });
  });

  return components;
};

var getSegments = exports.getSegments = function getSegments(text) {
  return getComponents(text, /[\r\n]+/igm);
};

var getWords = exports.getWords = function getWords(text) {
  return getComponents(text, /[ -]+/igm);
};

var stripPunctuation = exports.stripPunctuation = function stripPunctuation(word) {
  return word.replace(/[^\w]/g, '');
};

var getWordDurationEquation = exports.getWordDurationEquation = function getWordDurationEquation(gentleWords) {
  var sum = [0, 0, 0, 0, 0];

  gentleWords.filter(function (word) {
    return word.start !== undefined;
  }).forEach(function (word) {
    var wordLength = stripPunctuation(word.word).length;
    var wordDuration = word.end - word.start;
    sum[0] += wordLength;
    sum[1] += wordDuration;
    sum[2] += wordLength * wordLength;
    sum[3] += wordLength * wordDuration;
    sum[4] += wordDuration * wordDuration;
  });

  var run = gentleWords.length * sum[2] - sum[0] * sum[0];
  var rise = gentleWords.length * sum[3] - sum[0] * sum[1];
  var gradient = run === 0 ? 0 : rise / run;
  var intercept = sum[1] / gentleWords.length - gradient * sum[0] / gentleWords.length;

  return { gradient: gradient, intercept: intercept };
};

var getEstimatedWordDuration = exports.getEstimatedWordDuration = function getEstimatedWordDuration(length, _ref) {
  var gradient = _ref.gradient,
      intercept = _ref.intercept;
  return intercept + length * gradient;
};

var interpolateSegmentWordTimings = exports.interpolateSegmentWordTimings = function interpolateSegmentWordTimings(segmentWords, wordDurationEquation) {
  var interpolatedSegmentWords = [];

  for (var i = 0; i < segmentWords.length; i += 1) {
    if (!segmentWords[i].startTime) {
      var untimedWords = [];

      while (segmentWords[i] && !segmentWords[i].startTime) {
        untimedWords.push(segmentWords[i]);
        i += 1;
      }

      var interpolatedUntimedWords = void 0;

      if (interpolatedSegmentWords.length === 0 && !segmentWords[i]) {
        // segment has no timed words
        interpolatedUntimedWords = untimedWords;
      } else {
        (function () {
          var relativeEstimatedWordTimings = untimedWords.reduce(function (words, word) {
            var startTime = words.reduce(function (total, _ref2) {
              var duration = _ref2.duration;
              return total + duration;
            }, 0);

            var duration = getEstimatedWordDuration(stripPunctuation(word.text).length, wordDurationEquation);

            return [].concat(_toConsumableArray(words), [{ startTime: startTime, duration: duration }]);
          }, []);

          var totalEstimatedDuration = relativeEstimatedWordTimings.reduce(function (total, _ref3) {
            var duration = _ref3.duration;
            return total + duration;
          }, 0);

          if (interpolatedSegmentWords.length === 0 || !segmentWords[i]) {
            var untimedStart = void 0;

            if (interpolatedSegmentWords.length === 0) {
              // untimed words are at start of segment
              untimedStart = segmentWords[i].startTime - totalEstimatedDuration;
            } else if (!segmentWords[i]) {
              // untimed words are at end of segment
              untimedStart = interpolatedSegmentWords[interpolatedSegmentWords.length - 1].endTime;
            }

            interpolatedUntimedWords = untimedWords.map(function (word, index) {
              return _extends({}, word, {
                startTime: untimedStart + relativeEstimatedWordTimings[index].startTime,
                endTime: untimedStart + relativeEstimatedWordTimings[index].startTime + relativeEstimatedWordTimings[index].duration
              });
            });
          } else {
            // untimed words are in the middle of segment
            var _untimedStart = interpolatedSegmentWords[interpolatedSegmentWords.length - 1].endTime;
            var untimedEnd = segmentWords[i].startTime;
            var untimedDuration = untimedEnd - _untimedStart;

            var actualToEstimatedUntimedRatio = untimedDuration / totalEstimatedDuration;

            interpolatedUntimedWords = untimedWords.map(function (word, index) {
              return _extends({}, word, {
                startTime: _untimedStart + relativeEstimatedWordTimings[index].startTime * actualToEstimatedUntimedRatio,
                endTime: _untimedStart + (relativeEstimatedWordTimings[index].startTime + relativeEstimatedWordTimings[index].duration) * actualToEstimatedUntimedRatio
              });
            });
          }
        })();
      }

      interpolatedSegmentWords.push.apply(interpolatedSegmentWords, _toConsumableArray(interpolatedUntimedWords));
    }

    if (segmentWords[i]) {
      interpolatedSegmentWords.push(segmentWords[i]);
    }
  }

  return interpolatedSegmentWords;
};

var GentleAdapter = function () {
  function GentleAdapter() {
    _classCallCheck(this, GentleAdapter);
  }

  _createClass(GentleAdapter, null, [{
    key: 'parse',
    value: function parse(gentle) {
      var segments = getSegments(gentle.transcript).map(function (segment) {
        return _extends({}, segment, { words: getWords(segment.text) });
      });

      gentle.words.forEach(function (gentleWord) {
        var segment = segments.find(function (s) {
          return s.startIndex <= gentleWord.startOffset && s.endIndex > gentleWord.endOffset;
        });

        var word = segment.words.find(function (w) {
          return segment.startIndex + w.startIndex <= gentleWord.startOffset && segment.startIndex + w.endIndex >= gentleWord.endOffset;
        });

        word.startTime = gentleWord.start;
        word.endTime = gentleWord.end;
      });

      var wordDurationEquation = getWordDurationEquation(gentle.words);

      var segmentsWithInterpolatedWords = segments.map(function (segment) {
        return _extends({}, segment, { words: interpolateSegmentWordTimings(segment.words, wordDurationEquation) });
      });

      var speakers = new _immutable2.default.List([new _Speaker2.default()]);

      var transcriptSegments = new _immutable2.default.List(segmentsWithInterpolatedWords
      // discard any segments without any timings
      .filter(function (segment) {
        return segment.words[0].startTime;
      }).map(function (segment) {
        return new _TranscriptSegment2.default({
          speaker: 0,
          words: new _immutable2.default.List(segment.words.map(function (word) {
            return new _TranscriptWord2.default({
              start: word.startTime,
              end: word.endTime,
              text: word.text
            });
          }))
        });
      }));

      return new _Transcript2.default({
        speakers: speakers,
        segments: transcriptSegments
      });
    }
  }]);

  return GentleAdapter;
}();

exports.default = GentleAdapter;